import { getRecentConversations } from '../business-logic/use-cases/GetRecentConversationsUseCase'

const base = ['global-command', 'recent-conversations']

export const recentConversationsQueryConfig = {
  getRecentConversations: () => ({
    queryKey: base,
    queryFn: getRecentConversations,
  }),
}
